<div rt="machine-summary">
  <div class="d-flex mb-1">
    <h4 class="section-title">{{ machine.year }} {{ machine.primaryType }}</h4>
    <div class="d-lg-none ml-auto pl-3" (click)="share()"><i class="icon-share text-red mr-1 fs-24"></i></div>
  </div>

  <div class="d-flex">
    <h2 class="model-header">{{ machine.make }} {{ machine.model }}</h2>
  </div>

  <ng-container *ngIf="!machine.buyItNowOnly && machine.status !== 'OnRent' && machine.rentalRate > 0">
    <div class="d-inline-flex flex-wrap">
      <common-top-owner *ngIf="machine.isTopOwner" class="mr-2 mb-1" [showTopOwner]="machine.isTopOwner"></common-top-owner>

      <div class="alert alert-success fs-13 p-1 font-weight-light d-flex align-items-center mb-1 mr-2" role="alert" *ngIf="machine.recentCancellations == 0">
        <i class="icon-insurance mr-1"></i> {{ machine.recentCancellations }} cancels in the past 3 months
      </div>

      <div class="alert alert-warning fs-13 p-1 font-weight-light d-flex align-items-center mb-1 mr-2" role="alert" *ngIf="machine.recentCancellations == 1">
        <i class="icon-notification1 mr-1"></i> {{ machine.recentCancellations }} cancel in the past 3 months
      </div>

      <div class="alert alert-danger fs-13 p-1 font-weight-light d-flex align-items-center mb-1 mr-2" role="alert" *ngIf="machine.recentCancellations > 1">
        <i class="icon-notification1 mr-1"></i> {{ machine.recentCancellations }} cancels in the past 3 months
      </div>

      <div class="alert alert-warning financing-badge fs-13 p-1 font-weight-light d-flex align-items-center mb-1 cursor-pointer mr-2" role="alert" *ngIf="machine.buyItNowEnabled || machine.rpoEnabled" (click)="scrollToFinancing()">
        <i class="icon-earnings mr-1"></i> Financing Available
      </div>

      <div 
        class="badge badge-success fs-13 p-1 font-weight-light d-flex align-items-center cursor-pointer rpo-badge-match-height" 
        *ngIf="machine.rpoEnabled"
        [ngbTooltip]="rpoTooltipContent"
        tooltipClass="rpo-tooltip-wide"
        placement="bottom"
        triggers="click"
        autoClose="outside"
        container="body"
      >
        <i class="icon-info mr-1"></i> Rent to Own Available
      </div>
    </div>

    <ng-template #rpoTooltipContent>
      <common-machine-rpo-table [machine]="machine" fontClass="fs-14"></common-machine-rpo-table>
    </ng-template>

    <div class="d-flex justify-content-between">
      <div class="d-flex flex-column price-column" *ngIf="listingPrice.weekly != null">
        <span class="font-weight-light fs-14">Weekly</span>
        <span class="text-success fs-40 teko">{{ listingPrice.weekly | currency: "USD":"symbol":"1.0-0" }}</span>
      </div>
      <div class="d-flex flex-column price-column" *ngIf="listingPrice.monthly != null">
        <span class="font-weight-light fs-14">Monthly</span>
        <span class="text-success fs-40 teko">{{ listingPrice.monthly | currency: "USD":"symbol":"1.0-0" }}</span>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="machine.status === 'OnRent' && machine.buyItNowEnabled">
    <div class="alert alert-warning fs-14 p-2 font-weight-light d-flex align-items-center mb-2" role="alert">
      <i class="icon-notification1 mr-2"></i> Currently Rented - Purchase Only
    </div>
  </ng-container>

  <div class="d-flex mb-2">
    <ng-container *ngIf="machine.location">
      <span class="subhead-2 mr-2">{{ machine.location | location: "cityState":false }}</span>
      <span class="text-light-grey mr-2">|</span>
    </ng-container>
    <span class="subhead-2 mr-2" *ngIf="machine.weight != null && machine.weight != 0">{{ machine.weight | number: "1.0-0" }} lbs</span>

    <span class="text-light-grey mr-2" *ngIf="machine.weight != null && machine.weight != 0">|</span>
    <span class="subhead-2" *ngIf="machine.usage != null && machine.usageAbbreviation !== 'none' && machine.usageLabel !== 'None'">
      {{ machine.usage | number: "1.0-0" }} {{ machine.usageLabel }}
    </span>
  </div>
  <div class="d-flex mb-2"></div>
</div>
